export default function TrustBar() {
  const features = [
    {
      icon: 'ri-time-line',
      text: '30+ Years Experience'
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Licensed & Insured'
    },
    {
      icon: 'ri-building-line',
      text: 'OSHA Compliant'
    },
    {
      icon: 'ri-home-smile-line',
      text: 'Residential + Commercial'
    }
  ];

  return (
    <section className="bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center justify-center space-x-3 text-white">
              <i className={`${feature.icon} text-2xl text-amber-500`}></i>
              <span className="text-sm font-medium">{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}